import { isArray } from "ngx-bootstrap";

export const GPT_FEATURE="GPT_FEATURE"

export const hasFeatureFlag=(featureFlag:string, featureFlagArray)=>{
    if(featureFlagArray  && isArray(featureFlagArray)){
        return featureFlagArray.includes(featureFlag);
    }else{
        return false
    }
}